import axios from "axios";
import { navigate } from "gatsby-link";

export const login = async () => {
  if (typeof window !== `undefined`) {
    window.location.href = `${process.env.GATSBY_WS_API_URL}/connexion?path=${window.location.href}`;
  }
};

const DISABLE_AUTHENTICATION = true

export const getUserInfo = async () => {
  if (DISABLE_AUTHENTICATION) {
    return
  }
  try {
    return await axios.get(`${process.env.GATSBY_WS_API_URL}/user/info`, {
      withCredentials: true,
    });
  } catch (error) {
    if (typeof window !== `undefined` && error?.response?.status === 401) {
      window.location.href = `${process.env.GATSBY_WS_API_URL}/connexion?path=${window.location.href}`;
    }
  }
};

export const getUserInfoWithoutLogin = async () => {
  if (DISABLE_AUTHENTICATION) {
    return {}
  }
  try {
    return await axios.get(`${process.env.GATSBY_WS_API_URL}/user/info`, {
      withCredentials: true,
    });
  } catch (error) {
    return "";
  }
};

export const userLogout = async () => {
  try {
    await axios.post(
      `${process.env.GATSBY_LOGOUT_URL}`,
      {},
      { withCredentials: true }
    );
    navigate("/");
  } catch (error) {
    return "";
  }
};



export const hasRoles = async (roles) => {
  const result = await getUserInfoWithoutLogin();
  let hasRoles = false;

  const userRoles = result?.data?.activeSIRoles?.map((role) =>
    role.toLowerCase()
  );
  if (userRoles) {
    roles?.forEach((role) => {
      if (userRoles.indexOf(role.toLowerCase()) !== -1) {
        hasRoles = true;
        return false;
      }
    });
  } else {
    hasRoles = false;
  }
  return hasRoles;
};
